<template>
  <img
    :src="src"
    :alt="`${brand.name} logo`"
    :class="{ 'brand-logo-invert': needsInvert }"
  />
</template>

<script setup>
import { computed } from 'vue'
import { useTheme } from 'vuetify'
import { useBrand } from '@/composables/useBrand'

const props = defineProps({
  variant: {
    type: String,
    default: 'color'
  }
})

const brand = useBrand()
const vuetifyTheme = useTheme()

const isDark = computed(() => vuetifyTheme.global.name.value === 'dark')

const needsInvert = computed(() => isDark.value && !brand.assets.wordmarkDark)

const src = computed(() => {
  if (isDark.value && brand.assets.wordmarkDark) {
    return brand.assets.wordmarkDark
  }

  return props.variant === 'mono' ? brand.assets.wordmarkMono : brand.assets.wordmarkColor
})
</script>

<style scoped>
.brand-logo-invert {
  filter: brightness(0) invert(1);
}
</style>
